/**
 * Created by Jonas Wålekvist on 2018-04-26.
 */

import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineLite} from "gsap"
import {DungeonQuestSymbolUtil} from "../../../utils/DungeonQuestSymbolUtil";
import {StateMatrix} from "../../../utils/StateMatrix";
import {DungeonQuest} from "../../DungeonQuest";
import {DungeonQuestGameConfig, DungeonQuestGameMode} from "../../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../../DungeonQuestSound";
import {ColossalSymbolInfo, DungeonQuestParsedGameData} from "../../server/data/DungeonQuestParsedGameData";
import {DungeonQuestRandomFeatureBaseController} from "../DungeonQuestRandomFeatureBaseController";
import {DungeonQuestRandomColossalWildIntroView} from "./DungeonQuestRandomColossalWildIntroView";
import {DungeonQuestRandomColossalWildView} from "./DungeonQuestRandomColossalWildView";


export class DungeonQuestRandomColossalWildController extends DungeonQuestRandomFeatureBaseController {
    private _view:DungeonQuestRandomColossalWildView;
    private _symbolToBeTransformed:string;
    private _symbolData:ColossalSymbolInfo;
    private _overlayReels:string[][];
    private _allOverlayPositions:[number, number][];
    private _introView:DungeonQuestRandomColossalWildIntroView;

    constructor(index:number, name:string) {
        super(index, name);
        this._introView = new DungeonQuestRandomColossalWildIntroView();
        this._view = new DungeonQuestRandomColossalWildView();
        DungeonQuest.randomColossalWild = this;
    }

    protected hasWin() {
        return this._mode == DungeonQuestGameMode.RANDOM_WILD_TRANSFORM;
    }

    protected addFeatureEventHandlers():void {
        //   EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onIdle());
    }

    protected parseFeatureSpecificGameData(data:ParsedGameData) {
        this._overlayReels = (<DungeonQuestParsedGameData>data).overlayReels;
        this._symbolToBeTransformed = (<DungeonQuestParsedGameData>data).symbolToBeTransformed;
        this._symbolData = (<DungeonQuestParsedGameData>data).bigSymbolInfoList[0];
        this._allOverlayPositions = DungeonQuestSymbolUtil.findOverlayPositions(this._overlayReels);
    }

    /*
        private onIdle() {
            if(this._mode == FifthElementGameMode.RANDOM_WILD_TRANSFORM && this._nextMode == FifthElementGameMode.NORMAL) {
                this.getEndAnimation();
            }
        }
    */

    private getEndAnimation():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => DungeonQuest.reelAreaEffectController.switchBackground(DungeonQuestGameMode.NORMAL));

        return tl;
    }

    protected getIntroFeatureAnimation():TimelineLite {
        const tl = new TimelineLite();

        tl.add([
            this._introView.getIntroAnimation(this._symbolToBeTransformed),
            () => SlotGame.sound.playEffect(DungeonQuestSound.RANDOM_WILD_INTRO),
            () => DungeonQuest.reelAreaEffectController.switchBackground(DungeonQuestGameMode.RANDOM_WILD_TRANSFORM),
        ]);
        // tl.add(() => FifthElementModeData.instance.activateHighlightedReels());
        tl.add(() => Logger.logDev("RandomColossalWildIntroComplete"), 2);

        return tl;
    }


    public onReelBounce(data:IReelStoppedData):void {
        if(!this.hasWin()) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        const tl:TimelineLite = new TimelineLite();
        /*
                const attentionAnimations:Timeline[] = this.getSymbolOverlayAttentionAnimations(data.reelId, this._allOverlayPositions);
                if(attentionAnimations.length > 0) {
                    tl.add(() => FifthElement.soundPlayer.playEffect(FifthElementSound.UPGRADE_ATTENTION));
                    tl.add(attentionAnimations, 0, "start", 0);
                }
        */

        //ending
        if(data.reelId == 4) {
            this._introView.reelStopped = true;
            let states:StateMatrix<string> = new StateMatrix<string>(5, 7, [0, 6], DungeonQuestGameConfig.instance.SYMBOL_STATES.dimmed.keyword);
            states.setStatesAt(this._allOverlayPositions, DungeonQuestGameConfig.instance.SYMBOL_STATES.highlighted.keyword);

            const highlightSymbols = DungeonQuestSymbolUtil.getSymbolsWithState(states, DungeonQuestGameConfig.instance.SYMBOL_STATES.highlighted.keyword);
            const dimmedSymbols = DungeonQuestSymbolUtil.getSymbolsWithState(states, DungeonQuestGameConfig.instance.SYMBOL_STATES.dimmed.keyword);
            let symbolAnims = DungeonQuestSymbolUtil.getSymbolStateAnimations(highlightSymbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.highlighted, 0.2);
            symbolAnims = symbolAnims.concat(DungeonQuestSymbolUtil.getSymbolStateAnimations(dimmedSymbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.dimmed, 0.2));

            const symbolAnimsTl = new TimelineLite();
            symbolAnimsTl.add(symbolAnims, 0, "start", 0);


            tl.add(() => this._introView.stopLoop());
            tl.add(this._view.getLandingAnimation(this._symbolData, this._symbolToBeTransformed, symbolAnimsTl));

            tl.add([
                this._view.getExplosionAnimation(),
                DungeonQuest.symbolTransformView.getNewShockWaveTransform(this._symbolData, this._allOverlayPositions)
            ]);
            tl.add(() => DungeonQuest.reelAreaEffectController.switchBackground(DungeonQuestGameMode.NORMAL));
        }

        tl.add(() => this.dispatchCompleteEvent(data.reelId));
    }

    protected resetFeature():void {
        super.resetFeature();
        this._introView.reelStopped = false;
    }

}